import { BoldLabel } from './styleComponents/BoldLabel';
import { ItalicLabel } from './styleComponents/ItalicLabel';
import { EmbeddedStylePlaceholderName, EmbeddedStyleRule } from './types';

/**
 * Registry of supported embedded-style placeholders.
 *
 * Each rule binds a `tagName` (from `EmbeddedStylePlaceholderName`) to the
 * inline `Component` that wraps the text between its open and close tags while
 * parsing. Multiple tag names can be mapped to the same component to provide
 * aliases (e.g. `BOLD` and `STRONG` both render with `BoldLabel`).
 *
 * To support a new style:
 *  1. Add the tag to `EmbeddedStylePlaceholderName`.
 *  2. Create a wrapper component in `./styleComponents/`.
 *  3. Add an entry here mapping the tag to the new component.
 */
export const EMBEDDED_STYLE_RULES: EmbeddedStyleRule[] = [
  {
    tagName: EmbeddedStylePlaceholderName.ITALIC,
    Component: ItalicLabel,
  },
  {
    tagName: EmbeddedStylePlaceholderName.BOLD,
    Component: BoldLabel,
  },
  {
    tagName: EmbeddedStylePlaceholderName.STRONG,
    Component: BoldLabel,
  },
];
